"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _ThemeHelper = require("../Utilities/ThemeHelper");

var _amber = _interopRequireDefault(require("@material-ui/core/colors/amber"));

var _green = _interopRequireDefault(require("@material-ui/core/colors/green"));

var styles = (0, _ThemeHelper.createStyles)(function (theme) {
  return {
    variantSuccess: {
      backgroundColor: _green.default[800],
      color: theme.palette.getContrastText(_green.default[800])
    },
    variantError: {
      backgroundColor: theme.palette.error.dark,
      color: theme.palette.getContrastText(theme.palette.error.dark)
    },
    variantInfo: {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.getContrastText(theme.palette.primary.dark)
    },
    variantWarning: {
      backgroundColor: _amber.default[600],
      color: theme.palette.getContrastText(_amber.default[600])
    },
    root: {},
    containerRoot: {
      // Fix issues with Material UI v4
      // TODO: Remove upon upgrade to MUI v5
      // https://github.com/iamhosseindhv/notistack/issues/394
      pointerEvents: "all",
      "& > div": {
        paddingTop: theme.spacing(1)
      }
    }
  };
});
exports.styles = styles;